import * as React from 'react';
import KendoReactDropDownTree from '@Shared.Angular/kendo.react/KendoReactDropDownTree';
import { FilterDescriptor } from '@progress/kendo-data-query';

const NameFilter = (props) => {
  const { data, field, onFilterChange } = props;

  const onCategorySelected = (
    id: string,
    _index: string,
    _name: string,
    item: object
  ) => {
    const filter: FilterDescriptor[] = [];
    if (item) {
      filter.push({ value: id, field: 'id', operator: 'eq' });
    }
    onFilterChange({ filter, field, syntheticEvent: null });
  };

  return (
    <div className="setup-categories-name-filter">
      <KendoReactDropDownTree
        id="setup-categories-name-filter-dropdown-tree"
        categories={data}
        categoryClicked={onCategorySelected}
        dataItemKey="id"
        textField="name"
        subItemsField="subCategories"
        placeholder="Search by Name"
        showFilter={true}
        className="setup-categories-name-filter-dropdown"
      />
    </div>
  );
};

export default NameFilter;
